var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetaBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.66,
    height: 15.408,
    viewBox: "0 0 29.66 15.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39414",
    "data-name": "Group 39414",
    transform: "translate(24109 -3264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58733",
    "data-name": "Path 58733",
    d: "M25.787,15.408H3.872A3.872,3.872,0,0,1,0,11.536V3.872A3.872,3.872,0,0,1,3.872,0H25.787a3.872,3.872,0,0,1,3.872,3.872v7.664a3.872,3.872,0,0,1-3.872,3.872",
    transform: "translate(-24109 3264)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39413",
    "data-name": "Group 39413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58734",
    "data-name": "Path 58734",
    d: "M2.72,11.97V3.439H5.357a3.043,3.043,0,0,1,2.03.594,2.167,2.167,0,0,1,.695,1.744A2.107,2.107,0,0,1,7.8,6.9a1.7,1.7,0,0,1-.785.685,1.492,1.492,0,0,1,.884.659A2.261,2.261,0,0,1,8.2,9.462a2.437,2.437,0,0,1-.682,1.875,2.808,2.808,0,0,1-1.978.633ZM4.444,7.007h.9A.912.912,0,0,0,6.353,5.958a1.206,1.206,0,0,0-.234-.832,1,1,0,0,0-.762-.252H4.444Zm0,1.254V10.54h1.1a.862.862,0,0,0,.7-.287,1.235,1.235,0,0,0,.241-.814q0-1.149-.833-1.178Z",
    transform: "translate(-24109 3264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58735",
    "data-name": "Path 58735",
    d: "M13.859,8.278H11.175V10.54h3.176v1.429h-4.9V3.438h4.886V4.874H11.175V6.889h2.684Z",
    transform: "translate(-24109 3264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58736",
    "data-name": "Path 58736",
    d: "M20.985,4.874H18.875v7.1H17.146v-7.1H15.073V3.438h5.912Z",
    transform: "translate(-24109 3264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58737",
    "data-name": "Path 58737",
    d: "M25.344,10.224h-2.35l-.457,1.746H20.715l2.666-8.532h1.576L27.64,11.97H25.8ZM23.369,8.788h1.594l-.8-3.041Z",
    transform: "translate(-24109 3264)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142773",
    "data-name": "Rectangle 142773",
    width: 29.66,
    height: 15.408,
    transform: "translate(-24109 3264)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaBtn);
export default __webpack_public_path__ + "static/media/beta_btn.5ae73c41a02560aa95bca525e4855566.svg";
export { ForwardRef as ReactComponent };